import styled from "styled-components";

interface Styles {
  position?: string;
  margin?: string;
  padding?: string;
}

export const ContainerExtraSmall = styled.section<Styles>`
  position: ${({ position }) => position || "relative"};
  display: block;
  margin: ${({ margin }) => margin || "auto"};
  padding: ${({ padding }) => padding || ""};
  max-width: 36.75rem;
`;